import { get, post } from  "@/utils/request";
// 分页获取公告
export const getMerchantOpinionListPage = data => post('opinion/getMerchantOpinionListPage', data);



// WEBPACK FOOTER //
// ./src/api/opinion.js